import { useContext, useState, useEffect } from 'react'
import DocumentTab from './documentTab'
import CustomExternalLink from '../../../../components/common/customExternalLink'
import { useGetDocumentsACQQuery } from '../../../../hooks/api/entreprises'
import { MRT_SortingState } from 'material-react-table'
import { ActiveEnterpriseContext } from '../../../../context/activeEnterpriseContext'

const DocumentsAcq = ({
  filter
}: {
  filter: any
}) => {
  const [sorting, setSorting] = useState<MRT_SortingState>([{ id: 'active_date', desc: true }])
  const [page, setPage] = useState('1')
  const { activeEnterprise } = useContext(ActiveEnterpriseContext)

  useEffect(() => {
    setPage('1')
  }, [filter])

  const { data, isFetching } = useGetDocumentsACQQuery(activeEnterprise.crm_id, {
    page,
    sort: sorting[0],
    filter,
  })

  return (
    <DocumentTab
      propsTable={{
        data: data?.data ?? [],
        state: { sorting, isLoading: isFetching },
        onSortingChange: (params) => {
          setPage('1')
          setSorting(params)
        },
        propsPagination: {
          page: Number(page),
          count: Number(data?.metadata?.total ?? 0) > 0 
            ? Math.ceil(Number(data?.metadata?.total ?? 0) / 10) 
            : 1,
          onChange: (e, index) => {
            setPage(index.toString())
          },
        },
    
      }}
      type='acq'
      text={
        <>
          Dans cet onglet se trouvent les documents mis à votre disposition par votre ACQ régionale.
          Pour consulter ou télécharger les documents réservés aux membres (modèles de documents
          juridiques, grilles des taux horaires au format Excel, etc) ou bien publics (fiches
          techniques, publications, etc.), visitez le{' '}
          <CustomExternalLink href={`${process.env.REACT_APP_ACQ_SITE}/documentation`}>
            Centre de documentation
          </CustomExternalLink>{' '}
          sur acq.org.
        </>
      }
    />
  )
}

export default DocumentsAcq
